'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGContainer = require('../SVGContainer');

var _SVGContainer2 = _interopRequireDefault(_SVGContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResyncIcon = function ResyncIcon(props) {
  return _react2.default.createElement(
    _SVGContainer2.default,
    props,
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'g',
        { transform: 'translate(2 4)' },
        _react2.default.createElement('path', { d: 'M22.607 3.143C20.36 1.048 17.433-.05 14.36.06c-3.2.112-6.257 1.605-8.386 4.097-1.373 1.607-2.26 3.507-2.62 5.548l-1.37-2.067c-.336-.504-1.015-.642-1.52-.306-.505.334-.643 1.015-.306 1.52l3.277 4.936c.39.62 1.34.656 1.792.054L9.013 9.53c.4-.454.355-1.147-.1-1.547-.454-.4-1.146-.354-1.545.1l-1.87 2.126c.28-1.707 1-3.296 2.14-4.63 1.733-2.028 4.21-3.24 6.797-3.332 2.486-.09 4.857.8 6.677 2.497 1.82 1.698 2.87 4 2.956 6.487.087 2.487-.8 4.857-2.495 6.677-1.698 1.818-4 2.868-6.488 2.955-.605.02-1.077.528-1.057 1.132.02.592.507 1.058 1.095 1.058h.04c3.07-.108 5.916-1.404 8.012-3.65 2.097-2.25 3.192-5.18 3.083-8.25-.107-3.07-1.404-5.916-3.65-8.012'
        })
      ),
      _react2.default.createElement('path', { d: 'M16.216 8.975c-.606 0-1.096.49-1.067 1.096v7.13h7.088c.605 0 1.096-.49 1.096-1.095 0-.606-.49-1.095-1.096-1.095h-4.926v-4.94c0-.604-.492-1.095-1.096-1.095' })
    )
  );
};

ResyncIcon.propTypes = {
  size: _react.PropTypes.oneOf(['small', 'medium', 'large'])
};

exports.default = ResyncIcon;